if (typeof MarqueeSection === 'undefined') {
  class MarqueeSection {
    constructor(section) {
      this.section = section;
      this.speed = this.section.dataset.speed;
      this.init();
    }

    init() {
      this.section.style.setProperty('--marquee-speed', `${this.speed}s`);
    }
  }

  window.MarqueeSection = MarqueeSection;
}

document.addEventListener('DOMContentLoaded', () => {
  const marqueeSections = document.querySelectorAll('.section-marquee');
  marqueeSections.forEach(section => new window.MarqueeSection(section));
});
